import { Component, Input, OnInit, inject } from '@angular/core';
import { ClrDatagridSortOrder, ClrLoadingState } from '@clr/angular';
import { Floorplan, Hallway, Room } from '../../models/bim-floor-plan';
import { XPROJBIMSERVICE, XprojBimService, Blob, Guid, XprojModalService } from 'xproj-lib';
import { Customer } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';

@Component({
  selector: 'app-bms-floorplans-editor',
  templateUrl: './bms-floorplans-editor.component.html',
  styleUrls: ['./bms-floorplans-editor.component.scss']
})
export class FloorplansEditorComponent implements OnInit{

  private xprojBimService: XprojBimService = inject(XPROJBIMSERVICE);
  private modalService: XprojModalService = inject(XprojModalService);

  @Input() nodeId : string;
  @Input() nodeTypeId : string;
  @Input() customer : Customer;
  @Input() saveEnabled : boolean = false;
  @Input() childFloorplans : { nodeId : string, nodeTypeId : string, name : string}[] = [];

  sizeOptions = [10, 20, 50, 100];
  ascSort = ClrDatagridSortOrder.ASC;

  floorplansOptions : { id : string, name : string}[] = [];

  loadingFloorPlan : ClrLoadingState = ClrLoadingState.DEFAULT;
  showSaved : boolean = false;

  plans : Floorplan[] = [];
  selectedPlan : Floorplan = null;
  selectedPlanId : { id : string, name : string };

  defaultFloorplanInfo : { nodeId : string, nodeTypeId : string, name : string};

  addFloorplanInfo : { nodeId : string, nodeTypeId : string, name : string};

  showAddFloorPlan : boolean = false;
  addFloor : number = 0;
  addDefault : boolean = true;

  constructor()
  {
    //this.initFloorplan();
  }


  ngOnInit(): void {
    //this.updateFloorplans();
  }


  async updateFloorplans() {
    try {
      this.loadingFloorPlan = ClrLoadingState.LOADING;
      let blob = await this.xprojBimService.getFloorplanFile(this.nodeId, this.customer.id);
      let json = new TextDecoder().decode(blob.data);
      this.plans = JSON.parse(json);
    }
    catch {
      this.plans = [];
    }
    finally {
      this.loadingFloorPlan = ClrLoadingState.DEFAULT;
    }

    if (!this.plans || !Array.isArray(this.plans)) {
      this.plans = [];
    }

    this.selectedPlan = this.plans.find(x => x.nodeId == this.nodeId && x.defaultPlan);
    if (!this.selectedPlan) {
      let defaultPlan = new Floorplan();
      defaultPlan.id = Guid.newGuid();
      defaultPlan.nodeId = this.nodeId;
      defaultPlan.nodeTypeId = this.nodeTypeId;
      defaultPlan.floor = -100;
      defaultPlan.defaultPlan = true;
      this.initFloorplan(defaultPlan);
      this.plans.push(defaultPlan);
      this.selectedPlan = defaultPlan;
    }

    this.floorplansOptions = [];
    this.plans.forEach(x => {

      if (x.nodeId == this.nodeId) {
        this.floorplansOptions.push({ id: x.id, name : 'Default' + (x.defaultPlan ? '' : (' - floor ' + x.floor))});
        this.selectedPlanId = this.floorplansOptions[0];
      }
      else {
        let childFloorplan = this.childFloorplans.find(childplan => childplan.nodeId == x.nodeId);
        if (childFloorplan) {
          this.floorplansOptions.push({ id: x.id, name : childFloorplan.name + (x.defaultPlan ? '' : ' - floor ' + x.floor)});
        }
      }
    });

    this.floorplansOptions = this.floorplansOptions.sort((a, b) => a.name < b.name ? -1 : 1);

    if (this.childFloorplans?.length > 0) {
      this.addFloorplanInfo = this.childFloorplans[0];
    }

    this.defaultFloorplanInfo = {nodeId: this.nodeId, nodeTypeId : this.nodeTypeId, name : 'Default'};
  }

  initFloorplan(plan : Floorplan) {
    plan.rooms= [
      {
        area: {
          position_x: 0,
          position_y: 0,
          size_x: 10,
          size_y: 10
        },
        matchesSuffix: "01"
      },
      {
        area: {
          position_x: 0,
          position_y: 10,
          size_x: 10,
          size_y: 10
        },
        matchesSuffix: "02"
      },
      {
        area: {
          position_x: 13,
          position_y: 10,
          size_x: 10,
          size_y: 10
        },
        matchesSuffix: "03"
      },
      {
        area: {
          position_x: 13,
          position_y: 0,
          size_x: 10,
          size_y: 10
        },
        matchesSuffix: "04"
      }
    ];
  }

  selectedFloorPlanChange($event) {
    if (this.selectedPlanId) {
      this.selectedPlan = this.plans.find(x => x.id == this.selectedPlanId.id);
    }
  }

  addFloorplan() {
    if (this.addFloorplanInfo) {
      if (this.addDefault) {
        if (this.plans.findIndex(x => x.nodeId == this.addFloorplanInfo.nodeId && x.defaultPlan) < 0) {
          let plan = new Floorplan();
          plan.id = Guid.newGuid();
          plan.nodeId = this.addFloorplanInfo.nodeId;
          plan.nodeTypeId = this.addFloorplanInfo.nodeTypeId;
          plan.floor = -100;
          plan.defaultPlan = true;
          this.initFloorplan(plan);
          this.plans.push(plan);
          this.selectedPlan = plan;

          this.floorplansOptions.push({ id: plan.id, name : this.addFloorplanInfo.name});
          this.selectedPlanId = this.floorplansOptions[this.floorplansOptions.length-1];
        }
      }
      else {
        if (this.plans.findIndex(x => x.nodeId == this.addFloorplanInfo.nodeId && x.floor == this.addFloor) < 0) {
          let plan = new Floorplan();
          plan.id = Guid.newGuid();
          plan.nodeId = this.addFloorplanInfo.nodeId;
          plan.nodeTypeId = this.addFloorplanInfo.nodeTypeId;
          plan.floor = this.addFloor;
          plan.defaultPlan = false;
          this.initFloorplan(plan);
          this.plans.push(plan);
          this.selectedPlan = plan;

          this.floorplansOptions.push({ id: plan.id, name : this.addFloorplanInfo.name + ' - floor ' + this.addFloor});
          this.selectedPlanId = this.floorplansOptions[this.floorplansOptions.length-1];
          this.floorplansOptions = this.floorplansOptions.sort((a, b) => a.name < b.name ? -1 : 1);

        }
      }
    }


  }

  async removeFloorplan() {
    if (this.selectedPlanId) {
      let doDelete = await this.modalService.ShowConfirmModalAsync({
        header: 'Delete floorplan',
        description: 'Delete floorplan, are you sure?',
        ok: 'Delete',
        cancel: 'Cancel'
      });

      if (doDelete) {
        this.plans = this.plans.filter(x => x.id != this.selectedPlanId.id);
        this.floorplansOptions = this.floorplansOptions.filter(x => x.id != this.selectedPlanId.id);

        if (this.floorplansOptions.length > 0) {
          this.selectedPlanId = this.floorplansOptions[0];
          this.selectedPlan = this.plans.find(x => x.id == this.selectedPlanId.id);
        }
      }
    }
  }

  async saveFloorplans() : Promise<boolean> {
    if (this.plans?.length > 0) {
      let json = JSON.stringify(this.plans);
      let byteString = json;// window.atob(json);
      let arrayBuffer = new ArrayBuffer(byteString.length);
      let int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }

      let blob = new Blob();
      blob.data = int8Array;

      let result = await this.xprojBimService.uploadFloorplanFile(this.nodeId, this.nodeId + '_floorplan', 'json',
          blob, this.customer.id);
      if (result) {
        this.showSaved = true;
        setTimeout(() => {
          this.showSaved = false;
        }, 2000);
      }

      return result;
    }

    return false;
  }


}
